import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

import {Localization} from '#core/localization.js';

const UIView = MojitoCore.Presentation.UIView;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const {FlexPane, Text} = MojitoPresentation.Components;

class MaintenanceViewComponent extends UIViewImplementation {
    render() {
        return (
            <FlexPane config={this.config.infoContainer}>
                <Text config={this.config.title}>{Localization.getTranslation('$MAINTENANCE_TITLE')}</Text>
                <Text config={this.config.text}>{Localization.getTranslation('$MAINTENANCE_TEXT')}</Text>
                {/*<img*/}
                {/*    src={absoluteUrlToInternalResource(this.config.logo.src)}*/}
                {/*    alt="maintenance"*/}
                {/*    style={{ maxWidth: '200px', height: 'auto', maxHeight: '60px' }}*/}
                {/*/>*/}
            </FlexPane>
        );
    }
}

export const MaintenanceView = UIView('MaintenanceView', MaintenanceViewComponent);
